// @flow
/* eslint-disable no-return-assign, jsx-a11y/media-has-caption, prefer-destructuring */

import React, { useRef, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import 'video.js/dist/video-js.min.css';
import Loading from 'client/components/Loading';
import history from 'client/utils/history';
// import VideoStatsManager from 'client/utils/videoStatsManager';
import { setLocalStorage, getLocalStorage } from 'client/utils/localStorage';
import { getVideoDetails, clearVideoDetails, toggleLike } from './redux';
import Styles from './styles';
// import PlayIconBlack from './assets/play-black.svg';
// import PlayIconWhite from './assets/play-white.svg';

type Props = {
  getVideoDetails : (data : string) => void,
  getVideoDetailsLoading : boolean,
  videoDetails : any,
  match : any,
  clearVideoDetails : () => void,
  toggleLike : () => void,
  likeStatus : string,
};

let player = null;
let playerScope = null;
let playButton = null;
let backButton = null;
let playerBackButton = null;
let likeButton = null;
let progressPoint = null;
let playerInitialized = false;
let firstPlay = false;
let activeItem = null;

const Play = ({
  match,
  getVideoDetails,
  videoDetails,
  clearVideoDetails,
  getVideoDetailsLoading,
  toggleLike,
  likeStatus,
} : Props) => {
  const [loading, setLoading] = useState(true);
  const [tenSeconds, setTenSeconds] = useState(null);
  const playerRef = useRef();

  const handleChangeActiveItem = ({
    nextActiveItem,
    activeItem,
  } : any) => {
    if (activeItem) {
      switch (activeItem) {
        case 1:
          if (backButton && backButton.classList) {
            backButton.classList.remove('active-item');
            if (playerBackButton && playerBackButton.classList) {
              playerBackButton.classList.remove('active-item');
            }
          }
          break;
        case 2:
          if (playButton && playButton.classList) {
            playButton.classList.remove('active-item');
          }
          break;
        case 3:
          if (progressPoint && progressPoint.classList) {
            progressPoint.classList.remove('active-item');
          }
          break;
        case 4:
          if (likeButton && likeButton.classList) {
            likeButton.classList.remove('active-item');
          }
          break;
        default:
          break;
      }
    }
    if (nextActiveItem) {
      switch (nextActiveItem) {
        case 1:
          if (backButton && backButton.classList) {
            backButton.classList.add('active-item');
            if (playerBackButton && playerBackButton.classList) {
              playerBackButton.classList.add('active-item');
            }
          }
          break;
        case 2:
          if (playButton && playButton.classList) {
            playButton.classList.add('active-item');
          }
          break;
        case 3:
          if (progressPoint && progressPoint.classList) {
            progressPoint.classList.add('active-item');
          }
          break;
        case 4:
          if (likeButton && likeButton.classList) {
            likeButton.classList.add('active-item');
          }
          break;
        default:
          break;
      }
    }
  };

  const handleUpdateActiveItem = (newValue : number) => {
    handleChangeActiveItem({ nextActiveItem: newValue, activeItem });
    activeItem = newValue;
  };

  const handleClickDownArrow = () => {
    if (
      player && player.paused()
      && (
        (firstPlay && activeItem && (activeItem < 4))
        || (!firstPlay && (activeItem && activeItem < 2))
      )
    ) {
      handleUpdateActiveItem(activeItem + 1);
    } else {
      player.pause();
    }
  };

  const handleClickUpArrow = () => {
    if (player && player.paused()) {
      if (activeItem && (activeItem > 1)) {
        handleUpdateActiveItem(activeItem - 1);
      }
    } else {
      player.pause();
    }
  };

  const handleMouseWheel = (data : any) => {
    let canChangeScroll = true;
    if (canChangeScroll) {
      if (data.wheelDeltaY < -10) {
        handleClickDownArrow();
      } else if (data.wheelDeltaY > 10) {
        handleClickUpArrow();
      }
      canChangeScroll = false;
      setTimeout(() => {
        canChangeScroll = true;
      }, 200);
    }
  };

  const handleLikeClick = () => {
    toggleLike();
  };

  const handleRemoteKeys = (event : any) => {
    switch (event.keyCode) {
      case 19:
      case 38:
        handleClickUpArrow();
        break;
      case 20:
      case 40:
        handleClickDownArrow();
        break;
      case 21:
      case 37:
        if (
          (player && !player.paused())
          || (player.paused() && activeItem && (activeItem === 3))
        ) {
          setTenSeconds('prev');
          playerScope.currentTime(player.currentTime() - 10);
          setTimeout(() => {
            setTenSeconds(null);
          }, 1000);
        }
        break;
      case 22:
      case 39:
        if (
          (player && !player.paused())
          || (player.paused() && activeItem && (activeItem === 3))
        ) {
          setTenSeconds('next');
          playerScope.currentTime(player.currentTime() + 10);
          setTimeout(() => {
            setTenSeconds(null);
          }, 1000);
        }
        break;
      case 23:
      case 13:
        if (player && !player.paused()) {
          player.pause();
        } else if (player.paused() && activeItem) {
          switch (activeItem) {
            case 1:
              history.goBack();
              break;
            case 2:
              player.play();
              break;
            case 3:
              break;
            case 4:
              if (likeButton && likeButton.onclick) {
                likeButton.onclick();
              } else {
                handleLikeClick();
              }
              break;
            default:
              break;
          }
        }
        break;
      default:
        break;
    }
  };

  const getDuration = getLocalStorage('aparatTvPlayer', _.get(match, ['params', 'id']));

  useEffect(() => {
    if (videoDetails.size === 0) {
      getVideoDetails(_.get(match, ['params', 'id']));
    }
    if (window) {
      window.addEventListener('keydown', handleRemoteKeys);
      window.addEventListener('wheel', handleMouseWheel);
    }

    return () => {
      if (player) {
        setLocalStorage('aparatTvPlayer', _.get(match, ['params', 'id']), player.currentTime());
      }

      if (playerScope && playerScope.dispose) {
        playerScope.dispose();
      }
      window.removeEventListener('keydown', handleRemoteKeys);
      window.removeEventListener('wheel', handleMouseWheel);
      clearVideoDetails();
      player = null;
      playerScope = null;
      playButton = null;
      backButton = null;
      playerBackButton = null;
      likeButton = null;
      progressPoint = null;
      playerInitialized = false;
      firstPlay = false;
      activeItem = null;
    };
  }, []);

  const playerInitialSuccess = () => {
    const barElm = document.getElementsByClassName('vjs-play-progress')[0];
    const buttonElm = document.getElementsByClassName('backButtonWrapper')[0];
    if (buttonElm && buttonElm.parentNode) {
      const cloneButton = buttonElm.cloneNode(true);
      cloneButton.onclick = history.goBack;
      document.getElementsByClassName('vjs-control-bar')[0].appendChild(cloneButton);
      const progressPointElemetn = document.createElement('div');
      if (progressPointElemetn && progressPointElemetn.classList) {
        progressPointElemetn.classList.add('progressPoint');
        barElm.appendChild(progressPointElemetn);
      }
      playButton = document.getElementsByClassName('vjs-big-play-button')[0];
      backButton = document.getElementsByClassName('backButton')[0];
      playerBackButton = document.getElementsByClassName('backButton')[1];
      progressPoint = document.getElementsByClassName('progressPoint')[0];

      const likeButtonElm = document.createElement('button');
      likeButtonElm.className = 'action-button';
      likeButtonElm.innerHTML = '<i class="fa fa-thumbs-up"></i>';
      likeButtonElm.onclick = handleLikeClick;

      // Set initial like status
      const likeData = videoDetails.get('Like');
      if (likeData && likeData.get('data')) {
        const status = likeData.getIn(['data', 'status']);
        if (status === 'like') {
          likeButtonElm.classList.add('liked');
        }
      }

      document.getElementsByClassName('vjs-control-bar')[0].appendChild(likeButtonElm);
      likeButton = likeButtonElm;

      // Add active-item class to play button initially
      if (playButton && playButton.classList) {
        playButton.classList.add('active-item');
      }

      setLoading(false);
      handleUpdateActiveItem(2);
      playerScope.on('pause', () => {
        if (!playerScope.seeking() && player.paused()) {
          handleUpdateActiveItem(2);
        }
      });
      playerScope.on('play', () => {
        if (!playerScope.seeking()) {
          handleUpdateActiveItem(null);
          firstPlay = true;
        }
      });
    }
  };

  const initialPlayer = (nextVideoDetails : any) => {
    let videoInfo = videoDetails;
    let defaultSource;
    let sources = [];

    if (
      (!videoInfo || (videoInfo && videoInfo.size === 0)) ||
      (nextVideoDetails && nextVideoDetails.size > 0)
    ) {
      videoInfo = nextVideoDetails;
    }

    if (videoInfo.get('file_link_all') && videoInfo.get('file_link_all').size > 0) {
      videoInfo.get('file_link_all').forEach((file : any) => {
        sources = [...sources, {
          src: file.getIn(['urls', 0]),
          profile: file.get('profile'),
          type: 'video/mp4',
        }];
      });
      defaultSource = sources.find((source : any) => source.profile === '480p');
      if (!defaultSource) {
        defaultSource = sources.find((source : any) => source.profile === '360p');
      }
      player = window.videojs(playerRef.current, {
        width: window.innerWidth,
        height: window.innerHeight,
        poster: videoInfo.get('big_poster'),
        controls: true,
        preload: 'auto',
        volume: 1.0,
        inactivityTimeout: 1000,
        techOrder: ['flash', 'html5'],
        flash: { swf: 'http://vjs.zencdn.net/swf/5.3.0/video-js.swf' },
        hlsjs: { favorNativeHLS: true },
        html5: { nativeTextTracks: false },
        sources: [defaultSource] || sources,
      }, function onPlayerReady() {
        this.on('ended', () => {
          setLocalStorage('aparatTvPlayer', _.get(match, ['params', 'id']), 0);
        });
        this.on('error', (event : any) => {
          if (event.type === 'error') {
            history.goBack();
          }
        });
        this.on('loadedmetadata', () => {
          if (getDuration === this.duration()) {
            this.currentTime(0);
          } else if (getDuration) {
            this.currentTime(getDuration);
          }
        });
        /*
        this.currentTime(videoInfo.getIn(['watch_action', 'last_watch_position', 'last_second']));
        new VideoStatsManager(this, { // eslint-disable-line
          stat_url: videoInfo.getIn(['watch_action', 'visit_url', 'formAction']),
          start: videoInfo.getIn(['watch_action', 'last_watch_position', 'last_second']),
          movie_id: videoInfo.getIn(['uid']),
          movieType: videoInfo.getIn(['serial', 'enable']) ? 'serial' : 'film',
          'frm-id': videoInfo.getIn(['watch_action', 'visit_url', 'frm_id']),
        });
        */
        // setTimeout(() => {
        //   this.src({ src: moviePseudoDefaultSrc, type: 'video/mp4' });
        //   this.play();
        // }, 10000);
        playerScope = this;
        playerInitialSuccess();
        setTimeout(() => {
          if (this.duration() === 0) {
            this.duration(videoInfo.get('duration') * 60);
          }
          setTimeout(() => {
            this.play();
          }, 500);
        }, 500);
      });
      const title = document.createElement('h1');
      title.classList.add('video-title');
      title.innerHTML = videoInfo.get('title');
      player.el().appendChild(title);
    }
  };

  useEffect(() => {
    if (!playerInitialized && videoDetails && (videoDetails.size > 0)) {
      playerInitialized = true;
      initialPlayer(videoDetails);
    }
  }, [videoDetails]);

  useEffect(() => {
    if (likeStatus && likeButton && likeButton.classList) {
      if (likeStatus === 'like') {
        likeButton.classList.add('liked');
      } else {
        likeButton.classList.remove('liked');
      }
    }
  }, [likeStatus]);

  return (
    <Styles>
      {
        (getVideoDetailsLoading || loading) &&
        <Loading />
      }
      <div>
        {
          (tenSeconds && (tenSeconds === 'next')) &&
          <div className="secondsWrapper right">
            <i className="fa fa-angle-double-right" />
            <h3>10 ثانیه</h3>
          </div>
        }
        {
          (tenSeconds && (tenSeconds === 'prev')) &&
          <div className="secondsWrapper left">
            <i className="fa fa-angle-double-left" />
            <h3>10 ثانیه</h3>
          </div>
        }
      </div>
      <div className="backButtonWrapper" style={{ visibility: firstPlay ? 'hidden' : 'visible' }}>
        <button className="backButton" onClick={history.goBack}>
          <i className="fa fa-angle-left" />
        </button>
      </div>
      <div className="playerWrapper">
        <div data-vjs-player>
          <video ref={playerRef} className="video-js" />
        </div>
      </div>
    </Styles>
  );
};

export default connect(
  (state : any) => ({
    getVideoDetailsLoading: state.getIn(['Play', 'getVideoDetailsLoading']),
    videoDetails: state.getIn(['Play', 'videoDetails']),
    getVideoDetailsFail: state.getIn(['Play', 'getVideoDetailsFail']),
    likeStatus: state.getIn(['Play', 'likeStatus']),
  }),
  { getVideoDetails, clearVideoDetails, toggleLike },
)(Play);
